<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    navigatorContacts: (navigatorContacts$ | async) || [],
    canDeleteContact: (canDeleteContact$ | async) || false
  }"
>
</ng-container>
<ng-template
  #template
  let-navigatorContacts="navigatorContacts"
  let-canDeleteContact="canDeleteContact"
>
  <div class="container" flexLayout="column">
    <div class="header" flexLayout="row" flexLayoutAlign="space-between center">
      <div flex class="title">Contacts</div>
      <button
        type="button"
        color="primary"
        [disabled]="formControl.disabled"
        mat-icon-button
        flexAlign="end"
        (click)="addOrEditContact('Add')"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="tableWrapper">
      <table mat-table [dataSource]="navigatorContacts">
        <!-- createdDateTime Column -->
        <ng-container matColumnDef="createdDateTime">
          <th mat-header-cell *matHeaderCellDef>Date / Time</th>
          <td mat-cell *matCellDef="let contact">
            {{ contact.createdDateTime | date: "MM/dd/yyyy h:mma" }}
          </td>
        </ng-container>

        <!-- contactType Column -->
        <ng-container matColumnDef="contactType">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let contact">{{ contact.contactType }}</td>
        </ng-container>

        <!-- result Column -->
        <ng-container matColumnDef="result">
          <th mat-header-cell *matHeaderCellDef>Result</th>
          <td mat-cell *matCellDef="let contact">{{ contact.result }}</td>
        </ng-container>

        <!-- notes Column -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>Notes</th>
          <td mat-cell *matCellDef="let contact">{{ contact.notes }}</td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="align-end">Actions</th>
          <td mat-cell *matCellDef="let contact; let i = index" class="align-end">
            <button
              type="button"
              color="primary"
              [disabled]="formControl.disabled"
              mat-icon-button
              (click)="addOrEditContact('Edit', contact)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            @if (canDeleteContact) {
              <button
                type="button"
                color="warn"
                [disabled]="formControl.disabled"
                mat-icon-button
                (click)="removeContact(contact)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let contact; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            No contacts available
          </td>
        </tr>
      </table>
    </div>
  </div>
</ng-template>
